import React from 'react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function Hero() {
  const handleCheckoutClick = () => {
    trackInitiateCheckout();
  };
  return <section className="bg-gradient-to-b from-brand-dark to-brand-dark2 pt-[110px] pb-10 px-5 relative overflow-hidden sm:pt-[100px] sm:px-4 sm:pb-9" data-id="element-108">
      <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%] bg-[radial-gradient(ellipse_at_center,rgba(230,57,70,0.08)_0%,transparent_60%)] animate-hero-glow pointer-events-none" data-id="element-109"></div>

      <div className="max-w-[1100px] mx-auto relative z-10" data-id="element-110">
        <div className="text-center mb-6" data-id="element-111">
          <div className="inline-flex items-center gap-2 bg-brand-red/15 border border-brand-red/40 rounded-full px-4 py-1.5 text-xs font-bold text-brand-red uppercase tracking-[1px]" data-id="element-112">
            <span data-id="element-113">🔥</span> Nuevo · Método 4C · Plan de 21 Días
          </div>
        </div>

        {/* Hero Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center mb-8" data-id="element-114">
          {/* Left Column - Text Content */}
          <div className="text-center lg:text-left" data-id="element-115">
            <h1 className="text-[clamp(28px,5vw,48px)] font-black leading-[1.1] text-white mb-5" data-id="element-116">
              "Trabajas Duro Toda la Semana
              <span className="text-brand-red block" data-id="element-117">
                y el Dinero Igual Desaparece"
              </span>
            </h1>

            <p className="text-[clamp(15px,2.5vw,18px)] text-brand-gray mb-8 leading-[1.6]" data-id="element-118">
              El Plan de 21 Días que le Enseña a Cualquier Trabajador con
              Ingreso Variable a{' '}
              <strong className="text-brand-light" data-id="element-119">
                Ponerse al Día, Cortar Pérdidas de Dinero y Negociar cuando
                Debemos Algo
              </strong>{' '}
              — Sin Ganar Más
            </p>
          </div>

          {/* Right Column - Book Image */}
          <div className="relative max-w-[400px] mx-auto lg:mx-0 lg:ml-auto" data-id="element-120">
            <img src="https://cdn.magicpatterns.com/uploads/cMXxfArFcnDdvQrAvqpVMt/ChatGPT_Image_25_mar_2026,_06_27_35_p.m..png" alt="CERO ATRASOS — Método 4C" className="w-full animate-float drop-shadow-[0_20px_40px_rgba(0,0,0,0.6)]" data-id="element-121" />
            <div className="absolute -bottom-3 -right-3 bg-brand-red text-white font-black text-[11px] px-3 py-1.5 rounded-full uppercase tracking-[1px] animate-float" style={{
            animationDelay: '0.5s'
          }} data-id="element-122">
              📘 eBook Digital
            </div>
          </div>
        </div>

        {/* Pricing Box */}
        <div className="bg-gradient-to-br from-brand-dark2 to-brand-dark3 border-2 border-brand-red rounded-[20px] p-8 max-w-[900px] mx-auto relative shadow-[0_0_40px_rgba(230,57,70,0.2)] sm:p-6 sm:px-4" data-id="element-123">
          <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-brand-red text-white text-[11px] font-black px-4 py-1 rounded-full whitespace-nowrap tracking-[1px]" data-id="element-124">
            ⚡ OFERTA ESPECIAL ⚡
          </div>

          <div className="flex flex-col items-center justify-center mb-6" data-id="element-125">
            {/* Pricing */}
            <div className="text-center mb-6" data-id="element-126">
              <div className="text-lg text-brand-gray line-through mb-1" data-id="element-127">
                Valor real: $81.00
              </div>
              <div className="text-[clamp(48px,8vw,64px)] font-black text-brand-yellow leading-none mb-2" data-id="element-128">
                $6.39
              </div>
              <div className="text-sm text-brand-green font-bold mb-4" data-id="element-129">
                ✅ Ahorras $74.61 hoy
              </div>
              <div className="flex items-center justify-center gap-2 text-[13px] text-brand-yellow font-bold" data-id="element-130">
                <span data-id="element-131">⚡</span> Descarga Inmediata
              </div>
            </div>

            {/* What's Included */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-left w-full max-w-[500px]" data-id="element-132">
              <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-133">
                <span className="shrink-0 text-sm" data-id="element-134">✅</span> eBook completo — 13
                capítulos
              </div>
              <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-135">
                <span className="shrink-0 text-sm" data-id="element-136">✅</span> Plan de 21 días
              </div>
              <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-137">
                <span className="shrink-0 text-sm" data-id="element-138">✅</span> 5 Scripts de
                negociación
              </div>
              <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-139">
                <span className="shrink-0 text-sm" data-id="element-140">✅</span> 4 Mini-plantillas
                LITE
              </div>
              <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-141">
                <span className="shrink-0 text-sm" data-id="element-142">✅</span> 3 Ejemplos reales
              </div>
              <div className="flex items-center gap-2.5 text-sm text-brand-light" data-id="element-143">
                <span className="shrink-0 text-sm" data-id="element-144">✅</span> Garantía de 30 días
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="mt-6" data-id="element-145">
            <a href="https://www.betterdailyguides.com/cart/51869771923758:1" onClick={handleCheckoutClick} className="btn-buy-main block w-full text-white no-underline text-[clamp(16px,3vw,22px)] font-black py-5 px-7 rounded-xl uppercase tracking-[1px] transition-all duration-300 shadow-[0_8px_30px_rgba(230,57,70,0.5)] text-center cursor-pointer border-none hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(230,57,70,0.6)]" data-id="element-146">
              🔥 QUIERO ACCESO INMEDIATO — $6.39
              <span className="block text-xs font-normal opacity-85 mt-1 normal-case tracking-normal" data-id="element-147">
                Descarga en segundos · PDF directo a tu dispositivo
              </span>
            </a>

            <div className="flex justify-center gap-5 flex-wrap mt-4 text-xs text-brand-gray" data-id="element-148">
              <span className="flex items-center gap-1" data-id="element-149">🔒 Pago seguro</span>
              <span className="flex items-center gap-1" data-id="element-150">
                📱 Cualquier dispositivo
              </span>
              <span className="flex items-center gap-1" data-id="element-151">
                💯 Garantía 30 días
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}